import { format, parseISO } from "date-fns";

const HAS_TIMEZONE_REGEX = /(Z|[+-]\d{2}:?\d{2})$/;

export const formatDateTime = (dateString: string): string => {
  if (!dateString) return "";

  try {
    const date = parseISO(dateString);

  
    const displayDate = HAS_TIMEZONE_REGEX.test(dateString.trim())
      ? new Date(date.getTime() + date.getTimezoneOffset() * 60000)
      : date;

    return format(displayDate, "MMM dd, yyyy, hh:mm a");
  } catch (error) {
    console.error("Invalid date format:", error);
    return dateString;
  }
};
